// @flow
import React from "react"
import { Text } from "componentsStyled/Typography"

const Empty = () => (
  <Text center nomargin>
    No results available.
  </Text>
)

export default Empty



// WEBPACK FOOTER //
// ./src/hoc/withEmpty/Empty/index.js